import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { DateInput } from 'ziphy-web-shared/basic/lib/forms/fields';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import { getDateProps } from './';
const DateDefault = ({ $element }) => {
    const { fieldProps } = useMemo(() => getDateProps($element), [$element.config]);
    const { renderType, field } = $element;
    if (renderType === 'plain') {
        return field.value ? _jsx("span", { children: formatDate(field.value) }) : null;
    }
    return _jsx(DateInput, Object.assign({ field: field }, fieldProps));
};
export default observer(DateDefault);
